import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStarWand: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="star-wand, magic"><path d="M17.7036 2.77002L11.9652 5.68903L6.22673 2.77002L7.22983 9.12918L2.68018 13.6843L9.03857 14.6955L11.9652 20.4297L14.8918 14.6955L21.2502 13.6843L16.7005 9.12918L17.7036 2.77002Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.69686 15.0845L4.07227 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStarWand;
